import React from 'react';
import { Header } from '../components/Header';
import { AngelikaSturnFooter } from '../components/AngelikaSturnFooter';
import { Link } from 'react-router-dom';
import * as Accordion from '@radix-ui/react-accordion';
import { ChevronsDownIcon } from 'lucide-react';
export function AngelikaSturnPaartherapiePage() {
  return <div className="min-h-screen bg-white" data-id="element-652">
      <Header data-id="element-653" />
      <main className="w-full pt-[152px]" data-id="element-654">
        <div className="w-full flex justify-center" data-id="element-655">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-656">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3hoUorArMNBxi4mEUaDMDR/Header-Paartherapie-Angelika_Sturny.jpg" alt="Paartherapie Header Bild" className="w-full h-full object-cover" data-id="element-657" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-658"></div>
            <div className="absolute inset-0 flex items-end pb-16 md:pb-24" data-id="element-659">
              <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-660">
                <div className="max-w-lg text-left" data-id="element-661">
                  <blockquote className="text-white text-2xl md:text-3xl font-light italic mb-4" data-id="element-662">
                    "Liebe ist der einzige Weg, einen anderen Menschen im
                    innersten Kern seiner Persönlichkeit zu erfassen."
                  </blockquote>
                  <p className="text-white text-xl" data-id="element-663">– Viktor Frankl</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-664">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-4" data-id="element-665">
            Paartherapie
          </h1>
          <h2 className="text-xl md:text-2xl font-light text-gray-600 mb-8" data-id="element-666">
            Beziehungen bewusst gestalten: Wenn Nähe und Verbindung wieder Raum
            brauchen
          </h2>
          <div className="text-lg text-gray-600 leading-relaxed space-y-6 mb-12" data-id="element-667">
            <p data-id="element-668">
              Beziehungen sind ein zentraler Bestandteil unseres Lebens – sie
              geben Halt, Nähe und Sinn. Und doch widmen wir ihnen oft erst dann
              gezielte Aufmerksamkeit, wenn Nähe verloren geht, Konflikte
              eskalieren oder grundlegende Fragen aufbrechen.
            </p>
            <p data-id="element-669">
              Besonders in Partnerschaften, in denen viel geleistet wird und der
              Alltag eng getaktet ist, bleibt wenig Raum für das, was uns als
              Paar ausmacht. Dabei ist es gerade diese Verbindung, die uns trägt
              – in guten wie in herausfordernden Zeiten.
            </p>
            <p data-id="element-670">
              Umso wichtiger ist es, in das zu investieren, was uns im Innersten
              trägt: unsere Verbindung zueinander.
            </p>
          </div>
          <div className="mb-12 bg-gray-50 p-8 rounded-lg" data-id="element-671">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-672">
              In der Paarberatung und Paartherapie biete ich Ihnen einen
              geschützten Raum, um…
            </h3>
            <ul className="space-y-3 text-lg text-gray-600" data-id="element-673">
              <li className="flex items-start" data-id="element-674">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-675"></div>
                <span data-id="element-676">festgefahrene Muster zu erkennen und zu verändern</span>
              </li>
              <li className="flex items-start" data-id="element-677">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-678"></div>
                <span data-id="element-679">
                  wieder in Kontakt zu kommen – mit sich selbst und miteinander
                </span>
              </li>
              <li className="flex items-start" data-id="element-680">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-681"></div>
                <span data-id="element-682">Konflikte konstruktiv zu bearbeiten</span>
              </li>
              <li className="flex items-start" data-id="element-683">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-684"></div>
                <span data-id="element-685">Nähe und Vertrauen neu zu beleben</span>
              </li>
              <li className="flex items-start" data-id="element-686">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-687"></div>
                <span data-id="element-688">gemeinsame Werte und Visionen zu klären</span>
              </li>
            </ul>
            <p className="text-lg text-gray-600 mt-6" data-id="element-689">
              Ob als Paar oder Einzelperson – Sie sind willkommen, mit dem, was
              Sie bewegt.
            </p>
          </div>
          <div className="mb-12 bg-blue-50 p-8 rounded-lg" data-id="element-690">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-691">
              Wann kann eine Paartherapie sinnvoll sein?
            </h3>
            <ul className="space-y-3 text-lg text-gray-700" data-id="element-692">
              <li className="flex items-start" data-id="element-693">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-694"></div>
                <span data-id="element-695">
                  Wenn Gespräche schwierig oder konflikthaft verlaufen
                </span>
              </li>
              <li className="flex items-start" data-id="element-696">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-697"></div>
                <span data-id="element-698">
                  Bei wiederkehrenden Missverständnissen oder emotionaler
                  Distanz
                </span>
              </li>
              <li className="flex items-start" data-id="element-699">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-700"></div>
                <span data-id="element-701">
                  In Phasen von Veränderung, z. B. Elternschaft, Umzug,
                  beruflicher Wandel
                </span>
              </li>
              <li className="flex items-start" data-id="element-702">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-703"></div>
                <span data-id="element-704">
                  Bei Fragen zu Trennung, Versöhnung oder Neuausrichtung
                </span>
              </li>
              <li className="flex items-start" data-id="element-705">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-706"></div>
                <span data-id="element-707">
                  Wenn Sie Ihre Beziehung bewusst gestalten und vertiefen
                  möchten
                </span>
              </li>
            </ul>
          </div>
          <div className="mb-12" data-id="element-708">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-709">
              Mein Ansatz:
            </h3>
            <div className="text-lg text-gray-600 leading-relaxed space-y-6" data-id="element-710">
              <p data-id="element-711">
                Eine Paartherapie ist ein individueller Prozess, der darauf
                abzielt, die Beziehung zwischen zwei Menschen zu verbessern, zu
                klären und bewusst zu gestalten. Ich arbeite systemisch und
                ressourcenorientiert – mit Blick auf die Dynamik zwischen Ihnen,
                auf Ihre individuellen Bedürfnisse und auf die Muster, die Ihre
                Beziehung prägen. Ziel ist es, neue Perspektiven zu eröffnen,
                gegenseitiges Verständnis zu fördern und gemeinsam tragfähige
                Lösungen zu entwickeln. Ich begleite Sie mit Klarheit, Empathie
                und einem offenen Blick für Ihre gemeinsame Geschichte.
              </p>
              <p className="font-medium" data-id="element-712">
                Paartherapie ist eine Einladung, sich selbst und den anderen neu
                zu entdecken.
              </p>
            </div>
          </div>
          <div className="mb-12" data-id="element-713">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-714">
              Was passiert in der Paartherapie?
            </h3>
            <Accordion.Root type="single" collapsible className="space-y-4" data-id="element-715">
              <AccordionItem value="item-1" title="Klärung der Ziele und Erwartungen" data-id="element-716">
                <p className="text-gray-600 leading-relaxed" data-id="element-717">
                  Im Erstgespräch lernen wir uns kennen und klären Ihre Wünsche
                  und Ziele. Hier besprechen wir, was sie als Paar in die
                  Therapie führt und welche konkreten Kommunikationsthemen und
                  Konflikte es zwischen ihnen gibt.
                </p>
              </AccordionItem>
              <AccordionItem value="item-2" title="Analyse der Beziehungsmuster" data-id="element-718">
                <p className="text-gray-600 leading-relaxed mb-3" data-id="element-719">
                  In den gemeinsamen Sitzungen analysieren wir, wie Sie als Paar
                  miteinander interagieren:
                </p>
                <ul className="space-y-2 ml-4" data-id="element-720">
                  <li className="flex items-start" data-id="element-721">
                    <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-722"></div>
                    <span className="text-gray-600" data-id="element-723">
                      Welche Reaktionen zeigen sich immer wieder?
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-724">
                    <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-725"></div>
                    <span className="text-gray-600" data-id="element-726">
                      Wie beeinflussen Herkunftsfamilien und frühere Erfahrungen
                      Ihre Beziehung?
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-727">
                    <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-728"></div>
                    <span className="text-gray-600" data-id="element-729">
                      Welche Bedürfnisse, Ängste oder Erwartungen stehen hinter
                      bestimmten Verhaltensweisen?
                    </span>
                  </li>
                </ul>
              </AccordionItem>
              <AccordionItem value="item-3" title="Intervention und Veränderungsarbeit" data-id="element-730">
                <p className="text-gray-600 leading-relaxed mb-3" data-id="element-731">
                  Wenn Beziehungsmuster erkannt und verstanden sind, beginnt die
                  eigentliche Veränderungsarbeit. Ziel ist es, neue Perspektiven
                  zu entwickeln und konkrete Handlungsmöglichkeiten zu
                  erschließen – individuell und als Paar.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-732">
                  In dieser Phase geht es darum, eingefahrene Dynamiken zu
                  unterbrechen, neue Kommunikationsformen zu erproben und
                  emotionale Bedürfnisse klarer zu benennen. Veränderung
                  entsteht nicht durch Druck, sondern durch Einsicht, Resonanz
                  und das Erleben neuer Erfahrungen im geschützten Rahmen.
                </p>
              </AccordionItem>
              <AccordionItem value="item-4" title="Reflexion und Integration" data-id="element-733">
                <p className="text-gray-600 leading-relaxed mb-3" data-id="element-734">
                  Fortschritte festigen und neue Muster verankern – Veränderung
                  braucht Zeit und Raum für bewusste Reflexion. In der letzten
                  Phase der Paartherapie geht es darum, gemeinsam
                  zurückzublicken: Was hat sich verändert? Welche neuen Muster
                  haben sich etabliert? Was funktioniert bereits gut – und wo
                  braucht es noch Geduld und Übung?
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-735">
                  Diese Reflexionsarbeit hilft, positive Entwicklungen zu
                  würdigen, Rückschritte realistisch einzuordnen und die
                  gemeinsame Beziehungsgestaltung nachhaltig zu stärken.
                </p>
              </AccordionItem>
            </Accordion.Root>
          </div>
          <div className="mb-12" data-id="element-736">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-737">
              Informationen zum Ablauf
            </h3>
            <div className="text-lg text-gray-600 leading-relaxed space-y-6 mb-8" data-id="element-738">
              <p data-id="element-739">
                Der Ablauf und die Methode können variieren, aber typischerweise
                umfasst dieser folgende Phasen:
              </p>
            </div>
            <Accordion.Root type="single" collapsible className="space-y-4" data-id="element-740">
              <AccordionItem value="item-5" title="Kontaktaufnahme" data-id="element-741">
                <p className="text-gray-600 leading-relaxed" data-id="element-742">
                  Der erste Schritt in eine gemeinsame Veränderung beginnt mit
                  einem offenen Gespräch. Manchmal geht der Wunsch nach
                  Unterstützung zunächst nur von einer Seite aus – das ist nicht
                  ungewöhnlich. Auch dann kann es sinnvoll sein, erste Schritte
                  zu besprechen und Orientierung zu gewinnen. Der erste Kontakt
                  kann dabei auch nur mit einem der Partner stattfinden.
                </p>
              </AccordionItem>
              <AccordionItem value="item-6" title="Start der Beratung" data-id="element-743">
                <p className="text-gray-600 leading-relaxed" data-id="element-744">
                  Entscheiden Sie sich für die Zusammenarbeit, beginnt die
                  eigentliche Paartherapie. In der Regel arbeiten wir in
                  Sitzungen à 90 Minuten – je nach Thema und Intensität.
                </p>
              </AccordionItem>
              <AccordionItem value="item-7" title="Dauer und Häufigkeit" data-id="element-745">
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-746">
                  Die Dauer der Beratung ist individuell. Manche Anliegen klären
                  sich in wenigen Sitzungen, andere benötigen mehr Zeit. Wie
                  viele Gespräche Sie in Anspruch nehmen möchten, richtet sich
                  nach der Komplexität der Themen und den Zielen, die sie
                  erreichen möchten.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-747">
                  In der Regel finden die Sitzungen im Abstand von zwei bis vier
                  Wochen statt, denn die wirkliche Veränderung entsteht in Ihrem
                  Alltag.
                </p>
              </AccordionItem>
            </Accordion.Root>
          </div>
          <div className="mt-8 text-center" data-id="element-748">
            <p className="text-gray-600 mb-4" data-id="element-749">
              Die Rahmenbedingungen wie Terminvereinbarung, Ablauf und Kosten
              finden Sie unter{' '}
              <Link to="/angelika_sturny/info" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-750">
                Info
              </Link>
              .
            </p>
            <p className="text-gray-600" data-id="element-751">
              Appointments are also possible in English. Please contact me via{' '}
              <a href="mailto:praxis@angelikasturny.com" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-752">
                email
              </a>{' '}
              for sessions in English!
            </p>
          </div>
        </div>
      </main>
      <AngelikaSturnFooter data-id="element-753" />
    </div>;
}
const AccordionItem = ({
  children,
  value,
  title
}: {
  children?: React.ReactNode;
  value: string;
  title: string;
}) => {
  return <Accordion.Item value={value} className="border-b border-gray-200 overflow-hidden" data-id="element-754">
      <Accordion.Header data-id="element-755">
        <Accordion.Trigger className="flex justify-between items-center w-full p-4 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-756">
          <span className="text-lg font-medium text-gray-700" data-id="element-757">{title}</span>
          <ChevronsDownIcon className="h-5 w-5 text-[#cda8be] transition-transform duration-300 ease-[cubic-bezier(0.87,0,0.13,1)] group-data-[state=open]:rotate-180" data-id="element-758" />
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content className="overflow-hidden data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp" data-id="element-759">
        <div className="p-4 bg-white" data-id="element-760">{children}</div>
      </Accordion.Content>
    </Accordion.Item>;
};